import { useDelay } from "@iventis/utilities";
import { useQuery, useQueryClient, UseQueryOptions } from "@tanstack/react-query";

/** ReactQuery useQuery hook which is only called after a set amount of time if the query key does not have a previous value */
export function useDelayGetQuery<TData>(
    queryKey: string[],
    apiFunction: () => Promise<TData>,
    delayAmountMs: number,
    options: UseQueryOptions
): { data: TData; isLoading: boolean } {
    const queryClient = useQueryClient();
    // If data has been previously set on the query key, don't delay
    const currentState = queryClient.getQueryState(queryKey);

    const delayComplete = useDelay(delayAmountMs, currentState?.data != null);

    const { isLoading, data } = useQuery(queryKey, apiFunction, {
        ...options,
        enabled: delayComplete && options.enabled,
    });

    return { data: data as TData, isLoading };
}
